package navigation.home.proposal.addeditproposal

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.stripe.domain.StripeClient
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.area.domain.repository.AreaRepository
import com.essntl.features.category.domain.repository.CategoryRepository
import com.essntl.features.client.domain.repository.ClientRepository
import com.essntl.features.file.domain.repository.FileRepository
import com.essntl.features.paymentlink.domain.repository.PaymentLinkRepository
import com.essntl.features.price.domain.repository.PriceRepository
import com.essntl.features.profile.domain.repository.ProfileRepository
import com.essntl.features.profile.domain.use_case.GetCurrentUserUseCase
import com.essntl.features.proposal.domain.repository.ProposalRepository
import com.essntl.features.proposal.domain.use_case.UpdateProposalServiceUseCase
import com.essntl.features.proposal.ui.addeditproposal.AddEditProposalEvent
import com.essntl.features.proposal.ui.addeditproposal.AddEditProposalState
import com.essntl.features.proposal.ui.addeditproposal.AddEditProposalValidation
import com.essntl.features.proposal.ui.addeditproposal.AddEditProposalViewModel
import com.essntl.features.task.domain.repository.TaskRepository
import com.essntl.features.task.domain.use_case.AddTaskUseCase
import com.essntl.features.task.domain.use_case.DeleteTaskUseCase
import com.essntl.features.task.domain.use_case.UpdateTaskUseCase
import com.essntl.features.travelagent.domain.repository.TravelAgentRepository
import com.essntl.toastmanager.ToastManager

class AddEditProposalScreenModel(
    proposalRepository: ProposalRepository,
    priceRepository: PriceRepository,
    taskRepository: TaskRepository,
    travelAgentRepository: TravelAgentRepository,
    areaRepository: AreaRepository,
    categoryRepository: CategoryRepository,
    profileRepository: ProfileRepository,
    fileRepository: FileRepository,
    clientRepository: ClientRepository,
    paymentLinkRepository: PaymentLinkRepository,
    stripeClient: StripeClient,
    updateProposalServiceUseCase: UpdateProposalServiceUseCase,
    getCurrentUserUseCase: GetCurrentUserUseCase,
    addTaskUseCase: AddTaskUseCase,
    updateTaskUseCase: UpdateTaskUseCase,
    deleteTaskUseCase: DeleteTaskUseCase,
    toastManager: ToastManager,
    loadingManager: LoadingManager,
    proposalId: String?,
) : StateScreenModel<AddEditProposalState>(AddEditProposalState()) {
    val validation = AddEditProposalValidation()

    val vm =
        AddEditProposalViewModel(
            proposalRepository = proposalRepository,
            priceRepository = priceRepository,
            taskRepository = taskRepository,
            travelAgentRepository = travelAgentRepository,
            areaRepository = areaRepository,
            categoryRepository = categoryRepository,
            fileRepository = fileRepository,
            profileRepository = profileRepository,
            paymentLinkRepository = paymentLinkRepository,
            clientRepository = clientRepository,
            stripeClient = stripeClient,
            updateProposalServiceUseCase = updateProposalServiceUseCase,
            scope = screenModelScope,
            state = mutableState,
            toastManager = toastManager,
            loadingManager = loadingManager,
            proposalId = proposalId,
            validation = validation,
            getCurrentUserUseCase = getCurrentUserUseCase,
            addTaskUseCase = addTaskUseCase,
            updateTaskUseCase = updateTaskUseCase,
            deleteTaskUseCase = deleteTaskUseCase,
        )

    fun onEvent(event: AddEditProposalEvent) = vm.onEvent(event)
}